/**
 * Global registry for the WebGL renderer used in the editor
 * Allows screenshot capture from outside the React Three Fiber Canvas
 */

let _editorRenderer = null;

export function registerEditorRenderer(gl) {
  _editorRenderer = gl;
  console.log('[Screenshot] Editor renderer registered');
}

export function getEditorRenderer() {
  return _editorRenderer;
}

export function unregisterEditorRenderer() {
  _editorRenderer = null;
}
